class CartEditButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const key = this.dataset.key;
      const id = this.dataset.id;
      const index = this.dataset.index;
      const handle = this.dataset.handle;
      const url = this.dataset.url;
      localStorage.setItem('edit-product', id);
      localStorage.setItem('edit-product-key', key);
      localStorage.setItem('edit-product-index', index);
      localStorage.setItem('edit-product-handle', handle);
      window.location.href = url;
    });
  }
}

customElements.define("cart-edit-button", CartEditButton);
class UpsellSlider extends HTMLElement {
  constructor() {
    super();
    // this.init();
    // this.selectShipmentBtn();
    // this.backShipmentLayoutBtn();
  }

  selectShipmentBtn() {
    document.querySelector('.cart__select-shipment')?.addEventListener('click', function (event) {
      document.querySelector('.cart-content__layout').classList.add('d-none');
      document.querySelector('.shippment-content__layout').classList.remove('d-none');
    });
  }

  backShipmentLayoutBtn() {
    document.querySelector('.drawer__inner-shippment .back').addEventListener('click', function (event) {
      document.querySelector('.shippment-content__layout').classList.add('d-none');
      document.querySelector('.cart-content__layout ').classList.remove('d-none');
    });
  }
  init() {

    const selectBox = document.querySelector(".select-box");
    const selected = selectBox.querySelector(".selected");
    const optionsContainer = selectBox.querySelector(".options-container");
    const optionsList = selectBox.querySelector(".options-list");
    const Shipingoptions = optionsList.querySelectorAll(".select-box .option");

    selectBox.addEventListener("click", () => {
      optionsContainer.classList.toggle("active");
    });
    // Add click event listener to the label element
    const labels = document.querySelectorAll(".select-box label");

    labels.forEach(label => {
      label.addEventListener("click", () => {
        optionsContainer.classList.remove("active");
      });
    });

    document.addEventListener("click", (event) => {
      if (!selectBox.contains(event.target)) {
        optionsContainer.classList.remove("active");
      }
    });
    // Set the selected option and hide the options container
    Shipingoptions.forEach(option => {
      option.addEventListener("click", () => {
        selected.innerHTML = option.querySelector("label").innerHTML;
        const value = option.querySelector("input").value;
        handleChange(value);
      });
    });

    function handleChange(selectedOption) {
      const CartDrawerCheckout = document.querySelector('#CartDrawer-Checkout');
      const CalenderSelected = document.querySelector('#calendar .selected');
      if (selectedOption != '' && CalenderSelected != undefined) {
        var itemToUpdate = {};
        const selectedDate = CalenderSelected.dataset.date;
        itemToUpdate['Shipment Date'] = selectedDate;
        itemToUpdate['Shipment Time Slot'] = selectedOption;
        Shopify.theme.cart.updateAttributes(itemToUpdate, function (cart) {
        }).finally(() => {
          CartDrawerCheckout.disabled = false;
        });
      } else {
        CartDrawerCheckout.disabled = true;
      }

    }
    setTimeout(() => {
      new Swiper(".cart__upsell_slider", {
        spaceBetween: 40,
        speed: 500,
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination.upsell_pagination",
          clickable: true,
        },
        navigation: {
          prevEl: ".upsell-prev",
          nextEl: ".upsell-next",
        },
        on: {
          init: function () {
          },
        },
      });
    }, 0);
  }
}

customElements.define("upsell-slider", UpsellSlider);

(function () {

  const addonChecker = async function (details) {
   
    const update_addons = {};
    const add_addons = [];
    let qty = 0;
    const cartDrawer = document.querySelector('cart-drawer');
    const items = details.items;
    
    const temp = {};
    for (const item of items) {
      const handle = item.handle;
      const addon_item = item.properties['_package'];
      if(addon_item){
        // initialize addons with qty 0 for removing orphan addons 
        update_addons[item.key] = 0;
      }
      if (!temp[handle] && item.properties['Accessories']) {
        temp[handle] = {};
      }
      const addon_configs = Object.keys(item.properties).filter(key => key.startsWith('_pdp_addon'));
      for (const addon_config of addon_configs) {
        const prop = item.properties[addon_config];
        if (prop) {
          const id = prop.split(":")[0];
          const qty = parseInt(prop.split(":")[1]) ?? 0;
          temp[handle][id] = temp[handle][id] ? temp[handle][id] + qty : qty - 1;
        }
      }
    }
   
    for (const handle in temp) {
      const built_json = temp[handle];
      // identify addons already exist in cart and update according to configuration
      for (const item of items) {
        const prop = item.properties['_package'];
        const variant_id = JSON.stringify(item.variant_id);
        if (Object.keys(built_json).includes(variant_id) && prop == handle) {
          qty = built_json[variant_id];
          update_addons[item.key] = qty;
          delete built_json[variant_id];
        }
      }
      // if addons not exist in cart add in the cart according to configuration
      if(Object.keys(built_json).length > 0){
        for (const item of Object.keys(built_json)) {
          qty = built_json[item];
          if (qty > 0) {
            add_addons.push({ id: parseInt(item), quantity: qty, properties: { _package: handle } })
          }
        }
      }
    }

    let upodateResponse = '';
    if (add_addons.length > 0) {

      const payload = {
        items: add_addons,
        'sections': cartDrawer.getSectionsToRender().map((section) => section.id),
        'section_url': window.location.pathname
      };
      upodateResponse = await fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        ...{ body: JSON.stringify(payload) },
      }).then((res) => res.json())
        .catch((err) => console.log("Error", err));
      
    }

    if (Object.keys(update_addons).length > 0) {
      const payload = {
        updates: update_addons,
        'sections': cartDrawer.getSectionsToRender().map((section) => section.id),
        'section_url': window.location.pathname
      }
      upodateResponse = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{ body: JSON.stringify(payload) },
      }).then((res) => res.json())
        .catch((err) => console.log("Error", err));

    }

    if (upodateResponse) {
      cartDrawer.classList.toggle('is-empty', upodateResponse.item_count === 0);
      cartDrawer.renderContents(upodateResponse);
    }

  }

  document.addEventListener("cart:update", function (e) {
    const details = e.detail.cart;
    addonChecker(details)
    setTimeout(function (){
      document.querySelector('variant-radios')?.onVariantChange();
    },500);
    const LocalizationForm = document.querySelector('localization-form');
    LocalizationForm.changeCity();
  });
   function getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  document.addEventListener("cartitem:remove", async function (e) {
    const carthandle =  window.location.pathname.match(/\/products\/(.*)$/)[1];
    if(!carthandle) return false;
    const handle = e.detail.handle;
    const section_id = document.querySelector("variant-radios")?.dataset.section;
    const x =await fetch(window.location.pathname +"/"+handle+ "?sections[]="+section_id).then(res =>res.json())
    const sectioncontent = x[section_id];
    const  grid__item  = getSectionInnerHTML(sectioncontent,'.product__info-wrapper.grid__item');
    document.querySelector('.product__info-wrapper.grid__item').innerHTML = grid__item;
    const LocalizationForm = document.querySelector('localization-form');
    LocalizationForm.changeCity();
  });
})();